export const TUTORIAL_STATES = "TUTORIAL_STATES";

export const updateTutorialState = (status) => ({
  type: TUTORIAL_STATES,
  status,
});